export enum CustomerBillingProfitSortFieldEnum {
  CustomerName = 'customerName',
  Total = 'billAmountTotal',
  TotalPercentage = 'percentageOfGreatTotal',
}
